
















































































import { FNB_OWNER, YN } from '@/common';
import BaseComponent from '@/core/base.component';
import { FirstQuestionDto, Given, NextQuestionDto } from '@/dto';
import questionService from '@/services/question.service';
import QuestionService from '@/services/question.service';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'MultipleQuestion',
})
export default class MultipleQuestion extends BaseComponent {
  @Prop() readonly fnbOwnerStatus: FNB_OWNER;
  @Prop() readonly ipAddress: string;
  @Prop() readonly uniqueSessionId: string;
  private givens: Given[] = [];
  private question = '';
  private nextQuestionDto = new NextQuestionDto();
  private firstQuestionDto = new FirstQuestionDto();
  private questionGivenArray: any[] = [];
  private selectedAnswers: Given[] = [];
  private isMultipleAnswer = false;
  private smallSizeQuestionId = [1, 4, 5, 12];
  private nextQuestionDtoArr: NextQuestionDto[] = [];
  private isLastQuestion = false;

  getNextQuestion(given?: Given) {
    this.$emit('progressUp');

    // 답변을 하나만 선택할때
    if (given) {
      this.nextQuestionDto.givenId.push(given.id);
    } else {
      //답변을 여러개 선택할때
      this.$set(this.nextQuestionDto, 'givenId', this.selectedAnswers);
      const selectedGivenId = this.selectedAnswers.map(e => e.id);
      this.nextQuestionDto.givenId = selectedGivenId;
    }
    //questionGivenArray에 지금까지의 질문과 답변 저장
    this.questionGivenArray.push({
      questionId: this.nextQuestionDto.questionId,
      givenId: this.nextQuestionDto.givenId,
    });
    // this.resultRequestDto.questionGivenArray = this.questionGivenArray;
    this.nextQuestionDtoArr.push({ ...this.nextQuestionDto });
    //마지막 질문 given 선택하면 데이터 안받고 solution으로 이동
    if (this.isLastQuestion) {
      this.$emit('next', { questionGivenArray: this.questionGivenArray });
      this.$gtag.event(
        `question_${this.nextQuestionDto.userType}_${this.nextQuestionDto.questionId}_last_question`,
      );
      return;
    }

    this.$emit('loading', true);
    questionService.getNextQuestion(this.nextQuestionDto).subscribe(res => {
      this.$emit('loading', false);
      if (res) {
        this.nextQuestionDto.order = res.data.order;
        this.nextQuestionDto.questionId = res.data.id;
        this.$gtag.event(`question_${res.data.userType}_${res.data.id}`);
        this.question = res.data.question;
        //   this.questionOrder =
        //     this.nextQuestionDto.order + (this.prevOrder - 1);
        this.givens = res.data.givens;
        this.nextQuestionDto.givenId = [];
        this.isMultipleAnswer =
          res.data.multipleAnswerYn === YN.YES ? true : false;
        this.isLastQuestion = res.data.isLastQuestion === YN.YES ? true : false;
        this.selectedAnswers = [];
      }
    });
  }

  onMultipleAnswerClicked(given: Given) {
    if (this.selectedAnswers.includes(given)) {
      const theIndex = this.selectedAnswers.findIndex(e => e === given);
      this.selectedAnswers.splice(theIndex, 1);
    } else {
      this.selectedAnswers.push(given);
    }
  }

  onPrevious() {
    this.$emit('progressDown');
    if (this.questionGivenArray.length === 0) {
      //multiple의 첫번째 질문일때
      this.$emit('previous');
    } else if (this.questionGivenArray.length === 1) {
      this.getFirstQuestion();
    } else {
      this.$emit('loading', true);
      questionService
        .getNextQuestion(
          this.nextQuestionDtoArr[this.nextQuestionDtoArr.length - 2],
        )
        .subscribe(res => {
          this.$emit('loading', false);
          this.nextQuestionDto.order = res.data.order;
          this.nextQuestionDto.questionId = res.data.id;
          this.$gtag.event(`question_${res.data.userType}_${res.data.id}`);
          this.question = res.data.question;
          //   this.questionOrder =
          //     this.nextQuestionDto.order + (this.prevOrder - 1);
          this.givens = res.data.givens;
          this.nextQuestionDto.givenId = [];
          this.isMultipleAnswer =
            res.data.multipleAnswerYn === YN.YES ? true : false;
          this.isLastQuestion =
            res.data.isLastQuestion === YN.YES ? true : false;
          this.selectedAnswers = [];
          this.nextQuestionDtoArr.pop();
          this.questionGivenArray.pop();
        });
    }
  }

  getFirstQuestion() {
    this.questionGivenArray = [];
    this.nextQuestionDtoArr = [];
    this.$emit('loading', true);
    QuestionService.getFirstQuestion(this.firstQuestionDto).subscribe(res => {
      if (res) {
        this.$emit('loading', false);
        this.givens = res.data.givens;
        this.question = res.data.question;
        this.nextQuestionDto.order = res.data.order;
        this.nextQuestionDto.questionId = res.data.id;
        // this.nextQuestionDtoArr.push({ ...this.nextQuestionDto });
        // this.isMultipleAnswer =
        //   res.data.multipleAnswerYn === YN.YES ? true : false;
      }
    });
  }

  mounted() {
    this.firstQuestionDto.userType = this.fnbOwnerStatus;
    this.nextQuestionDto.userType = this.fnbOwnerStatus;
    this.nextQuestionDto.ipAddress = this.ipAddress;
    this.nextQuestionDto.uniqueSessionId = this.uniqueSessionId;
    this.nextQuestionDto.givenId = [];
    this.getFirstQuestion();
  }
}
